import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  sendMagicLink,
  MAGIC_LINK_EMAIL_STORAGE_KEY,
} from '../../services/firebase/firebaseService';
import Image from '../../components/common/Image';
import {
  TaskyAlert,
  TaskyAuthLayout,
  TaskyButton,
} from '../../components/tasky';

const MagicLinkSentPage: React.FC = () => {
  const navigate = useNavigate();
  const [statusMessage, setStatusMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isResending, setIsResending] = useState(false);

  const savedEmail =
    typeof window !== 'undefined'
      ? window.localStorage.getItem(MAGIC_LINK_EMAIL_STORAGE_KEY)
      : null;

  const handleResend = async () => {
    setStatusMessage('');
    setErrorMessage('');

    if (!savedEmail) {
      setErrorMessage(
        'メールアドレスが見つかりません。お手数ですがもう一度 /signup からやり直してください。',
      );
      return;
    }

    setIsResending(true);
    try {
      await sendMagicLink(savedEmail);
      setStatusMessage('再送信しました。メールボックスをご確認ください。');
    } catch (err) {
      console.error('Resend magic link failed:', err);
      setErrorMessage('再送信に失敗しました。しばらく時間をおいて再度お試しください。');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <TaskyAuthLayout
      logo={<Image category="common" fileName="logo.png" alt="Tasky" width={100} />}
      title="メールを確認してください"
      description={
        savedEmail ? (
          <>
            <strong className="text-dark">{savedEmail}</strong>{' '}
            にログインリンクを送信しました。
            <br />
            メール内のリンクをクリックしてサインインしてください。
          </>
        ) : (
          'ログインリンクを送信しました。'
        )
      }
      footer="メールが届かない場合は、迷惑メールフォルダもご確認ください。"
    >
      {statusMessage && (
        <TaskyAlert tone="success" className="mb-4">
          {statusMessage}
        </TaskyAlert>
      )}

      {errorMessage && (
        <TaskyAlert tone="error" className="mb-4">
          {errorMessage}
        </TaskyAlert>
      )}

      <div className="space-y-3">
        <TaskyButton
          type="button"
          onClick={handleResend}
          isLoading={isResending}
          className="w-full"
        >
          {isResending ? '送信中...' : '再送信'}
        </TaskyButton>

        <TaskyButton
          type="button"
          variant="outline"
          onClick={() => navigate('/signup')}
          className="w-full"
        >
          メールを変更
        </TaskyButton>
      </div>
    </TaskyAuthLayout>
  );
};

export default MagicLinkSentPage;
